import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudCardModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { FreudButtonModule } from '@freud-ds/web-components';
import { FreudLoaderModule } from '@freud-ds/web-components';
import { FreudAlertMessagesModule } from '@freud-ds/web-components';
import { FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationsErrorModule } from '../notifications-error/notifications-error.module';
import { NotificationsListModule } from '../notifications-list/notifications-list.module';
import { NotificationsNotFoundModule } from '../notifications-not-found/notifications-not-found.module';
import { NotificationsCardComponent } from './notifications-card.component';

@NgModule({
	declarations: [NotificationsCardComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudCardModule,
		FreudTypographyModule,
		FreudButtonModule,
		NotificationsListModule,
		NotificationsNotFoundModule,
		NotificationsErrorModule,
		FreudLoaderModule,
		FreudAlertMessagesModule,
		FreudTooltipModule,
	],
	exports: [NotificationsCardComponent],
	providers: [],
})
export class NotificationsCardModule {}
